export const EVIDENCE_DESCRIPTIONS_ROUTES = {
  EVIDENCE_DESCRIPTIONS_LIST: {
    path: '/admin/templates/evidence-descriptions',
    name: 'evidence-description-templates',
  },
};
